import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

import { Badge } from '@/components/ui/badge'
import { Bell } from 'lucide-react' // Using lucide-react for icons
import { Button } from '@/components/ui/button'
import { NotificationPanel } from './notification-panel' // Import the panel
import { trpc } from '@/lib/trpc' // Import trpc client
import { useNotifications } from '@/hooks/use-notifications' // Import the hook
import { useTranslation } from 'react-i18next'

export function NotificationBell() {
	const { t } = useTranslation()
	const { unreadCount } = useNotifications() // Use the actual hook
	const utils = trpc.useUtils() // Get tRPC utils

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button
					variant='ghost'
					size='icon'
					className='relative rounded-full'
					aria-label={t('notifications.toggleLabel')}
					onClick={() => {
						// Invalidate queries when the bell is clicked to open the panel
						utils.notifications.getNotifications.invalidate()
						utils.notifications.getUnreadCount.invalidate()
					}}
				>
					<Bell className='h-4 w-4' />
					{unreadCount > 0 && (
						<Badge
							variant='destructive' // Or another variant for emphasis
							className='absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full p-1 text-xs'
						>
							{unreadCount > 9 ? '9+' : unreadCount}
						</Badge>
					)}
				</Button>
			</PopoverTrigger>
			<PopoverContent className='w-80 p-0' align='end'>
				<NotificationPanel />
			</PopoverContent>
		</Popover>
	)
}
